import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function Problem() {
  return <section className="py-20 relative overflow-hidden" data-id="element-112">
      {/* Colorful popcorn background */}
      <div className="absolute inset-0 z-0" data-id="element-113">
        <img src="https://images.unsplash.com/photo-1578849278619-e73505e9610f?w=1600&q=80" alt="" className="w-full h-full object-cover" aria-hidden="true" data-id="element-114" />
        <div className="absolute inset-0 bg-white/85 backdrop-blur-sm" data-id="element-115"></div>
      </div>

      <div className="container px-4 mx-auto max-w-3xl text-center relative z-10" data-id="element-116">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-117">
          <div className="inline-flex items-center gap-2 bg-palomitas-coral text-white px-5 py-2 rounded-full font-bold mb-8 text-sm uppercase tracking-wide shadow-lg" data-id="element-118">
            <AlertCircle size={18} data-id="element-119" />
            <span data-id="element-120">⚠️ ¿Te sentís identificada?</span>
          </div>
          <div className="bg-white/70 backdrop-blur-md rounded-3xl p-8 md:p-12 shadow-xl border border-palomitas-coral/20" data-id="element-121">
            <p className="text-2xl md:text-3xl font-serif text-palomitas-brown leading-relaxed" data-id="element-122">
              "Quizás hoy no llegás a fin de mes o tu trabajo no te gusta.
              Querés usar tu tiempo en generar ingresos extras y aportar en los
              gastos cotidianos con la familia."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}